import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 404px;
  
  iframe {
    margin-left: 0 !important;
  }
`;
